"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addBaseWidgets = void 0;
var AddressLookupWidget_1 = require("./AddressLookupWidget");
var CancellationNoticeWidget_1 = require("./CancellationNoticeWidget");
var ClaimsPolarAnswerWidget_1 = require("./ClaimsPolarAnswerWidget");
var CustomDatePickerWidget_1 = require("./CustomDatePickerWidget");
var CustomDateWidget_1 = require("./CustomDateWidget");
var CustomerCancellationReasonWidget_1 = require("./CustomerCancellationReasonWidget");
var CustomerSurveyFormWidget_1 = require("./CustomerSurveyFormWidget");
var CustomMonthWidget_1 = require("./CustomMonthWidget");
var CustomPageValidationWidget_1 = require("./CustomPageValidationWidget");
var CustomPolarAnswerWithNavigateButtonsWidget_1 = require("./CustomPolarAnswerWithNavigateButtonsWidget");
var CustomPolarAnswerWidget_1 = require("./CustomPolarAnswerWidget");
var DocumentsReceivalPreferenceQuestionWidget_1 = require("./DocumentsReceivalPreferenceQuestionWidget");
var FalconAutoCompleteQuestionWidget_1 = require("./FalconAutoCompleteQuestionWidget");
var FalconCheckboxWidget_1 = require("./FalconCheckboxWidget");
var FalconCustomRadioWidget_1 = require("./FalconCustomRadioWidget");
var FalconDynamicalAutoCompleteQuestionWidget_1 = require("./FalconDynamicalAutoCompleteQuestionWidget");
var FalconMultipleCheckboxWidget_1 = require("./FalconMultipleCheckboxWidget");
var FieldValidationWidget_1 = require("./FieldValidationWidget");
var InteractionFieldOutputWidget_1 = require("./InteractionFieldOutputWidget");
var InteractionFieldValidationAlertWidget_1 = require("./InteractionFieldValidationAlertWidget");
var InvalidNamePageValidatonWidget_1 = require("./InvalidNamePageValidatonWidget");
var MarketingPreferencesOutputWidget_1 = require("./MarketingPreferencesOutputWidget");
var ModalWidget_1 = require("./ModalWidget");
var PageValidationWidget_1 = require("./PageValidationWidget");
var PanelRoundTopWidget_1 = require("./PanelRoundTopWidget");
var PersonalInfoOutputWidget_1 = require("./PersonalInfoOutputWidget");
var QuoteRefNumOutputWidget_1 = require("./QuoteRefNumOutputWidget");
var StickyPriceWidget_1 = require("./StickyPriceWidget");
var SuccessModalWidget_1 = require("./SuccessModalWidget");
var DeclineTextOutputWidget_1 = require("./declineTextOutputWidget/DeclineTextOutputWidget");
var InfoRadioQuestionWidget_1 = require("./infoQuestionWidgets/InfoRadioQuestionWidget");
var InfoDropDownBoxQuestionWidget_1 = require("./infoQuestionWidgets/InfoDropDownBoxQuestionWidget");
var DelayedOverlayWidget_1 = require("./DelayedOverlayWidget");
var InfoMultipleCheckboxQuestionWidget_1 = require("./InfoMultipleCheckboxQuestionWidget");
var FalconRadioWithIdWidget_1 = require("./FalconRadioWithIdWidget");
var UnansweredQuestionsWarningWidget_1 = require("./UnansweredQuestionsWarningWidget");
var FalconNumberInputWidget_1 = require("./FalconNumberInputWidget");
var PolarAnswerWithArrayWidget_1 = require("./infoQuestionWidgets/PolarAnswerWithArrayWidget");
var DocumentListWidget_1 = require("./annual/motor/DocumentListWidget");
var StickyWebChatButtonWidget_1 = require("./StickyWebChatButtonWidget");
var DealershipNumberWidget_1 = require("./driveAway/DealershipNumberWidget");
var IncludedAsStandardDriveAwayWidget_1 = require("./driveAway/IncludedAsStandardDriveAwayWidget");
var UniqueDriveAwaySellingPointWidget_1 = require("./driveAway/UniqueDriveAwaySellingPointWidget");
var CarPanelDriveAwayWidget_1 = require("./driveAway/CarPanelDriveAwayWidget");
var AnnualQuoteSummaryPanelDriveAwayWidget_1 = require("./driveAway/AnnualQuoteSummaryPanelDriveAwayWidget");
var ContactDetailsModal_1 = require("./ContactDetailsModal");
var PolicyDocumentsDriveAwayWidget_1 = require("./driveAway/PolicyDocumentsDriveAwayWidget");
var CustomDatePickerAnnualAndDriveAwayWidget_1 = require("./CustomDatePickerAnnualAndDriveAwayWidget");
var CustomDatePickerWithExpiryDateWidget_1 = require("./CustomDatePickerWithExpiryDateWidget");
var DriveAwayRelationshipToAccountHolderDropdownWidgetWithModal_1 = require("./driveAway/DriveAwayRelationshipToAccountHolderDropdownWidgetWithModal");
var CommissionWording_1 = require("./CommissionWording");
var SimplifiedCustomDatePickerWidget_1 = require("./SimplifiedCustomDatePickerWidget");
var MotorRenewalReminderModal_1 = require("./motorCommon/MotorRenewalReminderModal");
var SupportPortalMTCInfoWidget_1 = require("./SupportPortalMTCInfoWidget");
var RenewalReactivationPremiumWidget_1 = require("./RenewalReactivationPremiumWidget");
var IneligibleForDriveawayModalWidget_1 = require("./driveAway/IneligibleForDriveawayModalWidget");
var EligibleForAnnualCoverBanner_1 = require("./driveAway/EligibleForAnnualCoverBanner");
var GenuinePartsWidget_1 = require("./driveAway/GenuinePartsWidget");
var addBaseWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "addressLookup",
        component: AddressLookupWidget_1.AddressLookupWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "cancellationNotice",
        component: CancellationNoticeWidget_1.CancellationNoticeWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "claimsPolarAnswer",
        component: ClaimsPolarAnswerWidget_1.ClaimsPolarAnswerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customDatePicker",
        component: CustomDatePickerWidget_1.CustomDatePickerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customDatePickerWithExpiryDate",
        component: CustomDatePickerWithExpiryDateWidget_1.default
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customDatePickerAnnualAndDriveAwayWidget",
        component: CustomDatePickerAnnualAndDriveAwayWidget_1.CustomDatePickerAnnualAndDriveAwayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customDate",
        component: CustomDateWidget_1.CustomDateWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customerCancellationReasons",
        component: CustomerCancellationReasonWidget_1.CustomerCancellationReasonWidget,
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customerSurveyForm",
        component: CustomerSurveyFormWidget_1.CustomerSurveyFormWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customMonth",
        component: CustomMonthWidget_1.CustomMonthWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customPageValidation",
        component: CustomPageValidationWidget_1.CustomPageValidationWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customPolarAnswer",
        component: CustomPolarAnswerWithNavigateButtonsWidget_1.CustomPolarAnswerWithNavigateButtonsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "customPolarAnswerWithoutNavigation",
        component: CustomPolarAnswerWidget_1.CustomPolarAnswerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "supportPortalCustomDatePicker",
        component: SimplifiedCustomDatePickerWidget_1.SimplifiedCustomDatePickerWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "documentsOutputModal",
        component: DocumentListWidget_1.DocumentListWidget,
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "documentsReceivalPreferenceQuestion",
        component: DocumentsReceivalPreferenceQuestionWidget_1.DocumentsReceivalPreferenceQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "autoCompleteBox",
        component: FalconAutoCompleteQuestionWidget_1.FalconAutoCompleteQuestionWidget,
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconCheckboxWidget",
        component: FalconCheckboxWidget_1.FalconCheckboxWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconRadio",
        component: FalconCustomRadioWidget_1.FalconCustomRadioWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "radioWithId",
        component: FalconRadioWithIdWidget_1.FalconRadioWithIdWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "autoCompleteBoxWithDynamicList",
        component: FalconDynamicalAutoCompleteQuestionWidget_1.FalconDynamicalAutoCompleteQuestionWidget,
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconMultipleCheckboxWidget",
        component: FalconMultipleCheckboxWidget_1.FalconMultipleCheckboxWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "fieldValidation",
        component: FieldValidationWidget_1.FieldValidationWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "interactionFieldOutput",
        component: InteractionFieldOutputWidget_1.InteractionFieldOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "interactionFieldValidationAlert",
        component: InteractionFieldValidationAlertWidget_1.InteractionFieldValidationAlertWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "invalidNamePageValidation",
        component: InvalidNamePageValidatonWidget_1.InvalidNamePageValidationWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "marketingPreferencesOutput",
        component: MarketingPreferencesOutputWidget_1.MarketingPreferencesOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "modal",
        component: ModalWidget_1.ModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "pageValidation",
        component: PageValidationWidget_1.PageValidationWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "unansweredQuestionsWarning",
        component: UnansweredQuestionsWarningWidget_1.UnansweredQuestionsWarningWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "panelRoundTop",
        component: PanelRoundTopWidget_1.PanelRoundTopWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "personalInfoOutputWidget",
        component: PersonalInfoOutputWidget_1.PersonalInfoOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "quoteRefNumOutput",
        component: QuoteRefNumOutputWidget_1.QuoteRefNumOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "stickyWebChatButton",
        component: StickyWebChatButtonWidget_1.StickyWebChatButtonWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "stickyPrice",
        component: StickyPriceWidget_1.StickyPriceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "successModal",
        component: SuccessModalWidget_1.SuccessModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "declineTextOutput",
        component: DeclineTextOutputWidget_1.DeclineTextOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "supportPortalMTCInfoDisplay",
        component: SupportPortalMTCInfoWidget_1.SupportPortalMTCInfoWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "infoRadio",
        component: InfoRadioQuestionWidget_1.InfoRadioQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "polarAnswerWithArray",
        component: PolarAnswerWithArrayWidget_1.PolarAnswerWithArrayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "infoDropDownBox",
        component: InfoDropDownBoxQuestionWidget_1.InfoDropDownBoxQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "delayedOverlay",
        component: DelayedOverlayWidget_1.DelayedOverlayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "infoMultipleCheckbox",
        component: InfoMultipleCheckboxQuestionWidget_1.InfoMultipleCheckboxQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconNumberInput",
        component: FalconNumberInputWidget_1.FalconNumberInputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "dealershipNumber",
        component: DealershipNumberWidget_1.DealershipNumberWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "includedAsStandardDriveAwayWidget",
        component: IncludedAsStandardDriveAwayWidget_1.IncludedAsStandardDriveAwayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "uniqueDriveAwaySellingPointWidget",
        component: UniqueDriveAwaySellingPointWidget_1.UniqueDriveAwaySellingPointWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "genuinePartsWidget",
        component: GenuinePartsWidget_1.GenuinePartsWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "carPanelDriveAwayWidget",
        component: CarPanelDriveAwayWidget_1.CarPanelDriveAwayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualQuoteSummaryPanelDriveAwayWidget",
        component: AnnualQuoteSummaryPanelDriveAwayWidget_1.AnnualQuoteSummaryPanelDriveAwayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "contactDetailsModal",
        component: ContactDetailsModal_1.ContactDetailsModal
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "policyDocumentsDriveAwayWidget",
        component: PolicyDocumentsDriveAwayWidget_1.PolicyDocumentsDriveAwayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "driveAwayRelationshipToAccountHolderDropdown",
        component: DriveAwayRelationshipToAccountHolderDropdownWidgetWithModal_1.DriveAwayRelationshipToAccountHolderDropdownWidgetWithModal
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "commissionWording",
        component: CommissionWording_1.CommissionWording
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "MotorRenewalReminderModal",
        component: MotorRenewalReminderModal_1.MotorRenewalReminderModal
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalReactivationPremiumWidget",
        component: RenewalReactivationPremiumWidget_1.RenewalReactivationPremiumWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "ineligibleForDriveawayModal",
        component: IneligibleForDriveawayModalWidget_1.IneligibleForDriveawayModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "eligibleForAnnualCoverBanner",
        component: EligibleForAnnualCoverBanner_1.EligibleForAnnualCoverBanner
    });
};
exports.addBaseWidgets = addBaseWidgets;
//# sourceMappingURL=index.js.map